import 'es6-object-assign/auto'
import 'core-js/features/string/repeat'
import 'core-js/features/string/includes'
import 'core-js/features/array/includes'
import 'core-js/features/object/entries'

import Vue from 'vue'
import VueMask from 'v-mask'
import VueAxios from 'vue-axios'

import 'stylesheets/psp/brussels/psp-sn.scss'

import router from '~routes/psp/router-sn'
import store from '~vue/store/psp/store'
import axios from '~plugins/axios'
import i18nBuilder from '~locale/psp/locale'
import useFormatCurrencyFilter from '~filters/format-currency'
import useLhFormatCurrencyFilter from '~filters/lh-format-currency'
import App from '~app/psp-sn.vue'
import { setBrand, Brand, brandPlugin } from '~utils/brand-provider'

const i18n = i18nBuilder(store, ['en', 'nl', 'de', 'fr'])

setBrand(Brand.Brussels)
Vue.use(brandPlugin, { i18n })

useFormatCurrencyFilter(i18n)
useLhFormatCurrencyFilter()

Vue.use(VueMask)
Vue.use(VueAxios, axios)

const [subdomain] = window.location.hostname.split('.')
axios.defaults.headers.common['X-FE-Subdomain'] = subdomain

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    render: (h) => h(App),
    router,
    i18n,
    store,
  }).$mount()

  document.body.appendChild(app.$el)
})
